import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { Link } from 'react-router-dom';
import i18next from 'i18next';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faFile from '@fortawesome/fontawesome-free-solid/faFile';

import { SelectInput } from '../SelectInput';
import { FileInput } from '../FileInput';

const validate = (values => {
    let errors = {};

    if (!values.deviceType) {
        errors.deviceType = i18next.t('messages.please-select-device-type');
    }

    if (!values.csvFile) {
        errors.csvFile = "Please select a CSV file";
    } else if (values.csvFile.type !== 'text/csv') {
        errors.csvFile = "File must be CSV format";
    }

    return errors;
});

class BulkRegistrationForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        }
    }

    render() {
        if (this.props.deviceTypeOptions) {
            return (
                <div>
                    <form onSubmit={this.props.handleSubmit}>
                        <div style={{padding: '10px 0px'}}>
                            <label>{i18next.t('form-labels.device-type')}</label>
                            <Field
                                name="deviceType"
                                options={this.props.deviceTypeOptions.filter(option => option.deviceType.deviceFunctionalType.token === 'sensor')}
                                component={SelectInput}
                                onChange={(option) => this.setState({selectedDeviceType: option.deviceType})}
                            />
                        </div>
                        {this.state.selectedDeviceType &&
                        <div>
                            <div>
                                <Field
                                    name="csvFile"
                                    component={FileInput}
                                    onChange={(event, value) => this.setState({selectedFile: value})}
                                />
                            </div>
                            <div>
                                {this.state.selectedFile && 
                                <div style={{padding: '10px 0px'}}>
                                    <FontAwesomeIcon icon={faFile} size={'lg'} /> {this.state.selectedFile.name} ({this.state.selectedFile.size} bytes) 
                                </div>
                                }
                            </div>
                        </div>
                        }
                        <hr />
                        <ul className="list-inline clearfix">
                            <li><button type="submit" className="btn btn-primary btn-block">{ i18next.t('form-labels.save') }</button></li>
                            <li><Link to={ this.props.backLinkWithParams ? this.props.backLinkWithParams.link : `/config/devices`}><button className="btn btn-default">{ i18next.t('form-labels.cancel') }</button></Link></li>
                        </ul>
                    </form>
                </div>
            );
        } else {
            return (
                <div className="loader">{i18next.t('loading')}</div>
            )
        }
    }
}

export default reduxForm({ form: 'BulkRegistrationForm', validate })(BulkRegistrationForm);